{
  "linkTo": "Imposta percorso",
  "parkingSpotWithNumber": "Punto {{number}}",
  "pathNotSetWarning": "Percorso lineare non configurato. Imposta un percorso per abilitare le funzionalità di tracciamento dello spostamento lineare.",
  "setLinearPath": "Imposta percorso lineare",
  "stageParkingSpots": {
    "cancelText": "Indietro",
    "instructions": "Predisporre i posti auto lungo il percorso della stazione base.",
    "title": "Posti auto"
  },
  "stagePathEnd": {
    "cancelText": "Indietro",
    "instructions": "Imposta il punto finale del percorso della stazione base toccando la mappa.",
    "title": "Punto finale"
  },
  "stagePathStart": {
    "cancelText": "Cancellare",
    "instructions": "Imposta il punto di partenza del percorso della stazione base toccando la mappa.",
    "title": "Punto di partenza"
  },
  "stageSwath": {
    "cancelText": "Indietro",
    "instructions": "Imposta la larghezza della falciatura. Premi 'Flip' per invertire la direzione della falciatura.",
    "title": "Striscia"
  },
  "title": "Imposta percorso di spostamento lineare"
}
